<template>
  <div class="rt-lookup-view">
    <el-row>
      <el-col :span="4">{{ $tx('搜索', 'lookup.search_label') }}</el-col>
      <el-col :span="20">
        <el-input
          v-model="queryValue"
          :placeholder="$tx('搜索记录', 'lookup.search_placeholder')"
          @keyup.enter.native="handleSearch"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            style="margin-top:-12px;"
            @click="handleSearch"
          />
        </el-input>
      </el-col>
    </el-row>
    <el-table
      v-loading="loading"
      ref="lookupTable"
      :data="tableData"
      height="450"
      style="width: 100%"
      highlight-current-row
      border
      stripe
      @current-change="handleCurrentChange"
      @row-dblclick="handleConfirm"
      @sort-change="handleSortChange"
    >
      <el-table-column width="55">
        <template slot-scope="scope">
          <i v-if="scope.row == currentRow" class="el-icon-check" />
        </template>
      </el-table-column>
      <slot />
    </el-table>
    <el-pagination
      :current-page="pageIndex"
      :page-size="pageSize"
      :page-sizes="pageSizes"
      :layout="layout"
      :total="totalRecordCount"
      @size-change="handleSizeChange"
      @current-change="handleIndexChange"
    />
    <span slot="footer" class="dialog-footer" style>
      <el-button @click="handleReset">
        {{ $tx('移除值', 'lookup.button_removeValue') }}
      </el-button>
      <el-button type="primary" @click="handleConfirm">{{
        $tx('确 定', 'lookup.button_ok')
      }}</el-button>
    </span>
  </div>
</template>

<script>
export default {
  name: 'RtLookupView',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    fetch: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      queryValue: '',
      loading: false,
      pageIndex: 1,
      pageSize: 20,
      layout: 'total, sizes, prev, pager, next',
      pageSizes: [10, 20, 30, 40, 50],
      totalRecordCount: 0,
      tableData: [],
      currentRow: null
    };
  },
  methods: {
    handleSearch() {
      this.pageIndex = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    handleSortChange() {},
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.loadData();
    },
    handleIndexChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.loadData();
    },
    handleConfirm() {
      this.$emit('confirm', this.currentRow);
    },
    handleReset() {
      this.currentRow = null;
      this.$emit('remove', this.currentRow);
    },
    loadData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.fetch(this.queryValue, this.pageSize, this.pageIndex)
        .then(res => {
          this.tableData = res.Data;
          this.totalRecordCount = res.TotalRecordCount;
          this.loading = false;
        })
        .catch(err => {
          rt.showErrorToast(err);
          this.loading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtLookupView.vue?affede52